// noinspection JSUnusedGlobalSymbols
import {getApolloClient, restartApollo} from "@/shared/apolloclient/apollo.client.ts";
//@ts-ignore
import LOGIN_QUERY from "../graphql/authentication/login.graphql";
//@ts-ignore
import LOGOUT_QUERY from "../graphql/authentication/logout.graphql";
//@ts-ignore
import IS_AUTHENTICATED_QUERY from "../graphql/authentication/authenticated.graphql";
import {Account, AuthenticationResponse} from "@/shared/graphql/types";
import {activeLanguage} from "@/shared/i18n/i18n.ts";

class AuthenticationService {
    private refreshPromise: Promise<boolean> = null;

    async login(username: String, password: String): Promise<AuthenticationResponse> {
        return (
            await getApolloClient().mutate({
                mutation: LOGIN_QUERY,
                variables: {
                    language: activeLanguage(),
                    username: username,
                    password: password
                }
            })
        ).data.tenant.login;
    };

    async logout(): Promise<void> {
        try {
            // First, complete the logout mutation
            const result = await getApolloClient().mutate({
                mutation: LOGOUT_QUERY,
                variables: {
                    language: activeLanguage()
                }
            });

            const success = result.data?.tenant?.logout?.success || false;

            if (success) {
                // After logout is complete:
                // 1. Stop all ongoing queries
                await restartApollo()
                // 2. Clear the store
                await getApolloClient().clearStore();
                // 3. Clear local storage
                localStorage.clear();
            } else {
                throw new Error('Logout failed');
            }
        } catch (error) {
            console.error('Error during logout:', error);
            throw error;
        }
    }

    async isAuthenticated(): Promise<Account> {
        // await this.refreshToken();
        const result = await getApolloClient().query({
            query: IS_AUTHENTICATED_QUERY,
            variables: {
                language: activeLanguage()
            },
            fetchPolicy: 'no-cache'
        });
        return result?.data?.tenant?.me;
    }

    async refreshToken(): Promise<boolean> {
        if (this.refreshPromise) return this.refreshPromise;
        const url = import.meta.env.VITE_GRAPHQL_API;
        const query = `
            mutation refreshToken {
                tenant {
                    refresh
                }
            }`;

        const response = await fetch(url, {
            method: "POST",
            credentials: 'include',
            headers: {"Content-Type": "application/json", "Accept": "application/json"},
            body: JSON.stringify({query: query, variables: {}})
        });

        const responseJson = await response.json();
        const authenticationError = responseJson.errors?.find((error: any): boolean =>
            error?.extensions?.response?.status == 401 || error?.extensions?.exception?.message == "Unauthorized");
        const success = responseJson.data?.tenant?.refresh || false;
        if (response.status !== 200 || authenticationError || !success) {
            console.log(`Token refresh was not possible. Requesting new authentication. Status code = ${response.status}`);
            this.refreshPromise = null;
            return false;
        } else {
            this.refreshPromise = null;
            return true;
        }
    }
}

export const authenticationService = new AuthenticationService();

export default authenticationService